export default __webpack_public_path__ + "static/media/pass.0477f071.svg";